import { computed } from '@vue/composition-api'
import store from '@/store'
import { UPDATE_PRODUCT_INFO } from '@/store/modules/productEdit.module'

export const useInventory = () => {
  const isCarton = computed({
    get() {
      return store.state.productEdit.newData.isCarton
    },
    set(value) {
      store.commit(UPDATE_PRODUCT_INFO, { fieldName: 'isCarton', newValue: value })
    },
  })

  const items = computed({
    get() {
      return store.state.productEdit.newData.items
    },
    set(value) {
      const normalized = value.map(item => ({
        ...item,
        value: item.value !== '' ? Number(item.value) : item.value,
      }))
      store.commit(UPDATE_PRODUCT_INFO, { fieldName: 'items', newValue: normalized })
    },
  })

  const minQtyPerSize = computed({
    get() {
      return store.state.productEdit.newData.minQtyPerSize
    },
    set(value) {
      store.commit(UPDATE_PRODUCT_INFO, { fieldName: 'minQtyPerSize', newValue: Number(value) })
    },
  })

  const minQtyPerStyle = computed({
    get() {
      return store.state.productEdit.newData.minQtyPerStyle
    },
    set(value) {
      store.commit(UPDATE_PRODUCT_INFO, { fieldName: 'minQtyPerStyle', newValue: Number(value) })
    },
  })

  return {
    isCarton,
    items,
    minQtyPerSize,
    minQtyPerStyle,
  }
}
